import React from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { Download } from 'lucide-react';
interface ReportPreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  reportTitle: string;
  columns: string[];
  sampleData: string[][];
  onDownload: () => void;
}
export function ReportPreviewModal({
  isOpen,
  onClose,
  reportTitle,
  columns,
  sampleData,
  onDownload
}: ReportPreviewModalProps) {
  return <Modal isOpen={isOpen} onClose={onClose} title={`${reportTitle} Preview`} size="xl" footer={<>
          <Button variant="outline" onClick={onClose} data-id="element-55">
            Close
          </Button>
          <Button onClick={onDownload} data-id="element-56">
            <Download className="h-4 w-4 mr-2" data-id="element-57" />
            Download CSV
          </Button>
        </>} data-id="element-54">
      <div className="space-y-4" data-id="element-58">
        <p className="text-sm text-gray-600" data-id="element-59">
          Preview of first {sampleData.length} rows. Download the full report as
          CSV.
        </p>

        <div className="overflow-x-auto border border-gray-200 rounded-lg" data-id="element-60">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-61">
            <thead className="bg-gray-50" data-id="element-62">
              <tr data-id="element-63">
                {columns.map((col, idx) => <th key={idx} className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-64">
                    {col}
                  </th>)}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-65">
              {sampleData.map((row, rowIdx) => <tr key={rowIdx} className="hover:bg-gray-50" data-id="element-66">
                  {row.map((cell, cellIdx) => <td key={cellIdx} className="px-4 py-3 text-sm text-gray-900 whitespace-nowrap" data-id="element-67">
                      {cell}
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>

        <p className="text-xs text-gray-500 italic" data-id="element-68">
          Showing {sampleData.length} rows (preview only - full dataset
          available in CSV download)
        </p>
      </div>
    </Modal>;
}